import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Grid from "@material-ui/core/es/Grid";
import withStyles from "@material-ui/core/es/styles/withStyles";
import Typography from "@material-ui/core/es/Typography";
import { changePageHeader } from "../app/AppActions";
import Paper from "@material-ui/core/es/Paper";
import Grow from "@material-ui/core/es/Grow";
import DaInfoTable from "../delete-account/components/DaInfoTable";
import RtscInfo from "../delete-account/components/RtscInfo";
import Button from "@material-ui/core/es/Button";
import common from "@material-ui/core/colors/common";
import red from "@material-ui/core/colors/red";
import CircularProgress from "@material-ui/core/es/CircularProgress";
import {
  destroyAccount,
  getAccountPII,
  getAccountPIIStatus,
  getDestroyStatus,
  deleteShare
} from "../delete-account/DeleteAccountActions";
import { openConfirmationModal } from "../../components/confirmation-modal/ConfirmationModalActions";
import {FaCheck, FaWindowClose} from "react-icons/fa";
import * as classnames from "classnames";
import { openInformationModal } from "../../components/information-modal/InformationModalActions";
import UploadsInfoTable from "../delete-account/components/UploadsInfoTable";
import AppBar from "@material-ui/core/es/AppBar";
import Tabs from "@material-ui/core/es/Tabs";
import Tab from "@material-ui/core/es/Tab";

const white = common.white;
const red500 = red["500"];

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  deleteButton: {
    backgroundColor: red500,
    color: white
  },
  pageContainer: {
    padding: 24,
    marginBottom: 40
  },
  tableWrapper: {
    overflowX: "auto"
  },
  title: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: "0.7em 0",
    fontSize: "1.5rem",
    fontWeight: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.20588em"
  },
  accountEmail: {
    padding: ".3em 0 .7em 0",
    fontSize: "1rem",
    fontWeight: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  loadingCircleContainer: {
    textAlign: "center",
    paddingTop: "35px"
  },
  contactsList: {
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
    paddingRight: 1,
    maxHeight: 300,
    margin: "10px 0px 10px",
  },
  groupsList: {
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
    paddingRight: 1,
    maxHeight: 600,
    margin: "12px 0px"
  },
  ultraProfile: {
    padding: 15
  },
  gridList: {
    // width: 500,
    // height: 450,
    maxHeight: 400,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)"
  },
  expPanel: {
    width: "100%",
    boxShadow: "unset"
  },
  cardContent: {
    verticalAlign: "middle",
    paddingTop: 24
  },
  cardTitle: {
    alignSelf: "center",
    fontSize: "16px"
  },
  media: {
    height: 160,
    backgroundPosition: "center"
  },
  rightArrowIcon: {
    fontSize: 30
  },
  serviceHeadLine: {
    fontSize: 24,
    paddingTop: 32,
    lineHeight: "42px"
  },
  serviceContent: {
    marginTop: 16,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0
    }
  },
  serviceContentText: {
    color: "rgba(0,0,0,0.65)",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    whiteSpace: "pre-wrap"
  },
  serviceDivider: {
    marginTop: 56
  },
  infoTable: {
    marginBottom: 42
  },
  textAlignCenter: {
    textAlign: "center"
  },
  loadingCircleContainer: {
    textAlign: "center"
  },
  tableCell: {
    verticalAlign: "middle"
  },
  noInfoInTab: {
    padding: 24
  },
  button: {
    minWidth: 200
  },
  link: {
    color: "#0867b7 !important"
  }
});

class SharedEmails extends Component {
  state = { activeTab: 0 };

  componentWillMount() {
    const { user, brand, changePageHeader, getAccountPIIStatus } = this.props;
    changePageHeader("Delete your account", true);
    getAccountPIIStatus(user.email, brand.id);
  }

  componentDidMount() {
    const { user, brand, getAccountPII } = this.props;
    getAccountPII(user.email, brand.id);
  }

  openConfirmationModal = () => {
    const {
      user,
      brand,
      destroyAccount,
      openInformationModal,
      getAccountPIIStatus
    } = this.props;
    this.props.openConfirmationModal(
      `Are you sure you want to delete your ${user.email} account?`,
      () =>
        destroyAccount(
          user.email,
          brand.id,
          () => {
            getAccountPIIStatus(user.email, brand.id);
            openInformationModal("You have successfully deleted your account");
          },
          () =>
            openInformationModal(
              "There was an error deleting your account. Please try again."
            )
        )
    );
  };

  renderDestroyStatusIcon(status) {
    switch (status) {
      case "REQUESTED":
        return <CircularProgress size={15} />;
      case "FAILED":
        return <FaWindowClose color={"red"} />;
      default:
        return <FaCheck color={"green"} />;
    }
  }

  getDateFormated(time) {
    const date = new Date(time);
    return date.toLocaleString();
  }

  renderButton = () => {
    const {
      classes,
      user,
      app,
      brand,
      account,
      getDestroyStatus,
      getAccountPII
    } = this.props;
    if (account.fetchingPiiStatus) {
      return (
        <div className={classes.loadingCircleContainer}>
          <CircularProgress size={50} />
        </div>
      );
    } else if (account.piiStatus) {
      return (
        <Grid container justify="center">
          <Grid item>
            <Button
              variant="raised"
              color="secondary"
              className={classes.button}
              onClick={this.openConfirmationModal}
            >
              Delete Account
            </Button>
          </Grid>
          {(app.env === "development" || app.env === "staging") && (
            <Grid item>
              <Button
                variant="raised"
                color="primary"
                className={classes.button}
                onClick={() => getDestroyStatus(user.email)}
              >
                Get Delete Status
              </Button>
            </Grid>
          )}
          <Grid item>
            <Button
              variant="raised"
              color="primary"
              className={classes.button}
              onClick={() => getAccountPII(user.email, brand.id)}
            >
              Show Personal Data
            </Button>
          </Grid>

          {account.destroy.detailsList && (
            <Grid item xs={12}>
              {account.destroy.detailsList.map((d, index) => (
                <Grow in key={d.id} timeout={index * 700 + 500}>
                  <div>
                    {`${d.component}: `}
                    {this.renderDestroyStatusIcon(d.status)}
                  </div>
                </Grow>
              ))}
            </Grid>
          )}
        </Grid>
      );
    }

    return (
      <Paper className={classes.pageContainer}>
        <Typography
          component="p"
          className={classnames(
            classes.serviceContentText,
            classes.textAlignCenter
          )}
        >
          Account not registered
        </Typography>
      </Paper>
    );
  };

  // componentWillMount = () => {
  //     this.props.changePageHeader('Account Management', true);
  // };

  toggleTabs = (e, activeTab) => this.setState({ activeTab });

  render() {
    const { activeTab } = this.state;
    const { classes, brand, account } = this.props;
    const {uploadsInfo} = account.pii;
    console.log(this.props)
    const tabs = Object.values(account.brandsPii)
        .map(({daInfo, uploadsInfo, rtsc}, index) => (
            <div key={index}>
                <DaInfoTable classes={classes} content={daInfo}/>
                <UploadsInfoTable classes={classes} content={uploadsInfo}/>
                <RtscInfo classes={classes} content={rtsc}/>
            </div>
        ));

    return (
      <div id="share-emails" style={{ padding: "10px 20px", textAlign: "center" }}>
        {account.fetchingPii ? (
          <div style={{ paddingTop: "30px" }}>
            <CircularProgress />
          </div>
        ) : uploadsInfo ?
            <Grid container justify='center' className={classes.serviceContent} spacing={24}>
                <Grid item xs={12} sm={10}>
                    {/* <DaInfoTable classes={classes}/> */}
                    <UploadsInfoTable classes={classes}/>
                    <RtscInfo classes={classes}/>
                </Grid>
                    {Object.keys(account.brandsPii).length > 0 &&
                <Grid item xs={12} sm={10}>
                    <AppBar position="static">
                        <Tabs value={activeTab} onChange={this.toggleTabs}>
                            {Object.keys(account.brandsPii).map(b => <Tab key={b} label={b}/>)}
                        </Tabs>
                    </AppBar>
                    <Paper>
                        {tabs[activeTab]}
                    </Paper>
                </Grid>}
            </Grid>
            : 
            <Grid container justify='center' className={classes.serviceContent} spacing={24}>
                <Paper style={{padding: '20px', fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)'}}>
                    Share your emails to see shared emails
                </Paper>
                
            </Grid>
        }
      </div>
      //             <div style={{padding: '10px'}}>
      //                 {/*<ServiceSection headLine="Delete your account or services"*/}
      //                 {/*text={`If you are no longer interested in using ${brand.name} services, you can delete them here.`}*/}
      //                 {/*image="http://da-v4-mbl.digitalbrandsinc.netdna-cdn.com/wp-content/uploads/2012/08/delete-612x320.jpg"*/}
      //                 {/*cardTitle="Delete Account" link="delete-account"/>*/}

      //                 {!account.fetchingPiiStatus && account.piiStatus ?
      //                     <div>
      //                         <Grid container justify='center'>
      //                             <Grid xs={12} sm={7} item>
      //                                 <Typography gutterBottom variant="headline" className={classes.serviceHeadLine}>
      //                                     {`How to Permanently Delete Your Account and All Information From ${brand.name} Cloud`}
      //                                 </Typography>
      //                             </Grid>
      //                         </Grid>
      //                         <Grid container justify='center' className={classes.serviceContent} spacing={24}>
      //                             <Grid xs={12} sm={7} item>
      //                                 <Typography component="p" className={classes.serviceContentText}>
      //                                     {`Permanently deleting your account, removes your account details from ${brand.name} cloud. After this is complete, you will no longer have access to your account on ${brand.name} and all traces of your account will be removed instantly as we do not store your emails on our servers.

      // If you would like to permanently delete your account, please do the following:
      // 1. Remove your account from the ${brand.name} app on `}
      //                                     <strong style={{fontWeight: 800}}>all</strong>
      //                                     {` of your devices.`}
      //                                     <li style={{paddingLeft: '1.5rem'}}>You can remove your account within the app by
      //                                         tapping More (o o o) | Various Account Settings | Tap the account you wish to
      //                                         delete | Edit Account | Remove Account | Confirm with OK
      //                                     </li>
      //                                     {`2. Click the “Delete Account” button below and wait for confirmation.

      // Please Note: You will need to do the steps above for every account you wish to delete on ${brand.name}. This is a permanent action and cannot be undone.`}
      //                                 </Typography>
      //                             </Grid>
      //                         </Grid>
      //                     </div> :
      //                     <div/>
      //                 }
      //                 <Grid container justify='center' className={classes.serviceContent}>
      //                     <Grid xs={12} sm={7} item>
      //                         {this.renderButton()}
      //                     </Grid>
      //                 </Grid>
      //                 <Grid container justify='center' className={classes.serviceContent} spacing={24}>
      //                     <Grid item xs={12} sm={10}>
      //                         <DaInfoTable classes={classes}/>
      //                         <UploadsInfoTable classes={classes}/>
      //                         <RtscInfo classes={classes}/>
      //                     </Grid>
      //                         {Object.keys(account.brandsPii).length > 0 &&
      //                     <Grid item xs={12} sm={10}>
      //                         <AppBar position="static">
      //                             <Tabs value={activeTab} onChange={this.toggleTabs}>
      //                                 {Object.keys(account.brandsPii).map(b => <Tab key={b} label={b}/>)}
      //                             </Tabs>
      //                         </AppBar>
      //                         <Paper>
      //                             {/* {tabs[activeTab]} */}
      //                         </Paper>
      //                     </Grid>}
      //                 </Grid>

      //             </div>
    );
  }
}

function mapStateToProps({ user, brand, account, app }) {
  return { user, brand, account, app };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changePageHeader,
      getDestroyStatus,
      getAccountPII,
      destroyAccount,
      openConfirmationModal,
      getAccountPIIStatus,
      openInformationModal,
      deleteShare
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SharedEmails));



// WEBPACK FOOTER //
// ./src/containers/shared-emails/SharedEmails.js